import React, { useState, useEffect }  from 'react';
import './Profile.css';
import PersonalDetails from "./Profile/PersonalDetails"
import SubscriptionDetails from "./Profile/SubscriptionDetails"

function Profile(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma - User Profile";
    const [optionSelected, setOptionSelected] = useState("one");
    useEffect(() => {

    }, [])

    return (
        <div className="faq commonContainer" >
            <div className="container">
                <div className="ProfileContainer">
                    <div className="leftOptionProfile">
                        <div className="ProfileNav" onClick={() => setOptionSelected("one")} style={optionSelected === "one" ? { backgroundColor: "black", color: "white" } : {}}>
                            Personal Details
                        </div>

                        <div className="ProfileNav" onClick={() => setOptionSelected("five")} style={optionSelected === "five" ? { backgroundColor: "black", color: "white" } : {}}>
                            Subscription Details
                        </div>
                    </div>
                    <div className="RightDetailsProfile" style={{ paddingRight: "10px" }}>
                        {optionSelected === "one" &&
                            <PersonalDetails />
                        }
                        {optionSelected === "five" &&
                            <SubscriptionDetails />
                        }
                    </div>
                </div>

            </div>
        </div>
    );
}
export default Profile;